import {DIGITALCARD_MINIMUM_TALK_VERSION, ZIKZANGID_MINIMUM_TALK_VERSION} from '@zzng/common/scheme/digitalcard';
import {isValidTalkVersion, kakaoTalkVersion} from '@zzng/common/utils/agent';

/**
 * 디지털카드 스킴(digitalcard://)을 통해 열었을 때 전용웹뷰인지 인앱브라우저인지 확인하고 싶을 때 사용하는 변수
 * 예시) false > 유저가 채팅방에 disitalcard://open/url?url=URL 입력하여 열면 인앱브라우저가 열림
 * 예시) true > 유저가 채팅방에 disitalcard://open/url?url=URL 입력하여 열면 전용웹뷰가 열림
 */
export const isRequiredKakaotalkVersionForDigitalCard = isValidTalkVersion(
  kakaoTalkVersion,
  DIGITALCARD_MINIMUM_TALK_VERSION
);

/** 앱스킴 파라미터 target=_Blank를 지원하는 카카오톡 버전 */
export const isRequiredKakaotalkVersionForTargetBlank = isValidTalkVersion(
  kakaoTalkVersion,
  ZIKZANGID_MINIMUM_TALK_VERSION
);
